<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>管理员</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 管理员 strat -->
      <el-tab-pane name="first" label="管理员">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="userSearch">
          <el-form-item label="">
            <el-input v-model="userSearch.userName" @keyup.enter.native="clicksearch" placeholder="请输入登录账号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="userSearch.userNiceName" @keyup.enter.native="clicksearch" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="userSearch.idcardno" @keyup.enter.native="clicksearch" placeholder="请输入身份证号码"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="userSearch.roleid" placeholder="请选择角色" class="select2">
              <el-option
                v-for="item in optionsrole" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="userSearch.status" placeholder="请选择状态" class="select"  style="width: 150px;">
              <el-option label="禁用" value="0"></el-option>
              <el-option label="正常" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="userSearch.rulestatus" placeholder="是否敏感权限" class="select"  style="width: 150px;">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="userSearch.employeestype" placeholder="是否内部员工" class="select"  style="width: 150px;">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
              <el-option label="离职" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="机构(管理外部)">
            <RsljigouAll :propsjigouid="userSearch.jigouid" :propsjigouname="userSearch.jigouname" @change="changeRsljigouAll"></RsljigouAll>
          </el-form-item>
          <el-form-item label="机构(管理内部)">
            <RsljigouAll :propsjigouid="userSearch.jigouidneibu" :propsjigouname="userSearch.jigounameneibu" @change="changeRsljigouAllneibu"></RsljigouAll>
          </el-form-item>
          <el-form-item label="机构名称(实际行政归属)" class="addAdminForm">
            <RsljigouAll :propsjigouid="userSearch.jigouidactual" :propsjigouname="userSearch.jigounameactual" @change="changeRsljigouAllactual"></RsljigouAll>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->
        <!-- 管理员列表 start -->
        <el-table v-loading="loading" :data="adminList" border stripe>
          <el-table-column prop="id" label="ID" width="100px"></el-table-column>
          <el-table-column prop="loginname" label="登录账号"></el-table-column>
          <el-table-column prop="nicename" label="姓名"></el-table-column>
          <el-table-column prop="rolename" label="角色名称"></el-table-column>
          <el-table-column prop="jigouname" label="机构名称(管理外部)"></el-table-column>
          <el-table-column prop="jigounameneibu" label="机构名称(管理内部)"></el-table-column>
          <el-table-column prop="jigounameactual" label="机构名称(实际行政归属)"></el-table-column>
          <el-table-column prop="lastloginip" label="最后登录IP"></el-table-column>
          <el-table-column prop="lastlogintime" label="最后登录时间"></el-table-column>
          <el-table-column prop="userstatuss" label="状态"></el-table-column>
          <el-table-column prop="rulestatuss" label="敏感权限"></el-table-column>
          <el-table-column prop="employeestypes" label="是否内部员工"></el-table-column>
          <el-table-column prop="idcardno" label="身份证号码" width="200px"></el-table-column>
          <el-table-column prop="idcardname" label="身份证名字"></el-table-column>
          <el-table-column prop="operation" label="操作">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickeditUser(scope.$index,scope.row)">编辑</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="changestaus(scope.$index,scope.row)">切换状态</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="removeUserById(scope.$index,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 管理员列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="adminListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 管理员 end -->

      <!-- 编辑管理员弹出框 -->
      <el-dialog title="编辑管理员" :visible.sync="editUserInfo" width="600px" :close-on-click-modal="false">
        <el-form :model="addAaminForm" ref="addAaminFormRef" label-width="170px">
          <el-form-item label="机构名称(管理外部)" class="addAdminForm">
            <RsljigouAll :propsjigouid="addAaminForm.jigouid" :propsjigouname="addAaminForm.jigouname" @change="changeRsljigouAll"></RsljigouAll>
          </el-form-item>
          <el-form-item label="机构名称(管理内部)" class="addAdminForm">
            <RsljigouAll :propsjigouid="addAaminForm.jigouidneibu" :propsjigouname="addAaminForm.jigounameneibu" @change="changeRsljigouAllneibu"></RsljigouAll>
          </el-form-item>
          <el-form-item label="机构名称(实际行政归属)" class="addAdminForm">
            <RsljigouAll :propsjigouid="addAaminForm.jigouidactual" :propsjigouname="addAaminForm.jigounameactual" @change="changeRsljigouAllactual"></RsljigouAll>
          </el-form-item>
          <el-form-item label="姓名" class="addAdminForm">
            <el-input v-model="addAaminForm.nicename" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="登录名" class="addAdminForm">
            <el-input v-model="addAaminForm.loginname" placeholder="请输入登录名" disabled></el-input>
          </el-form-item>
          <el-form-item label="密码" class="addAdminForm">
            <el-input v-model="addAaminForm.password" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item label="角色"  class="addAdminForm">
            <el-select v-model="addAaminForm.roleid" placeholder="请选择角色" class="select2">
              <el-option
                v-for="item in optionsrole" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="敏感权限" class="addAdminForm">
            <el-select v-model="addAaminForm.rulestatus" placeholder="是否敏感权限" class="select"  style="width: 150px;">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否内部员工" class="addAdminForm">
            <el-select v-model="addAaminForm.employeestype" placeholder="是否内部员工" class="select"  style="width: 150px;">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
              <el-option label="离职" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证号码" class="addAdminForm">
            <el-input v-model="addAaminForm.idcardno" placeholder="请输入身份证号"></el-input>
          </el-form-item>
          <el-form-item label="身份证姓名" class="addAdminForm">
            <el-input v-model="addAaminForm.idcardname" placeholder="请输入身份证名"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksave">保存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 编辑管理员弹出框 end -->

    <!-- 添加管理员 start -->
    <el-tab-pane name="second" label="添加管理员">
      <el-form :model="addAaminForm" ref="addAaminFormRef" label-width="170px">
        <el-form-item label="机构名称(管理外部)" class="addAdminForm">
          <RsljigouAll :propsjigouid="addAaminForm.jigouid" :propsjigouname="addAaminForm.jigouname" @change="changeRsljigouAll"></RsljigouAll>
        </el-form-item>
        <el-form-item label="机构名称(管理内部)" class="addAdminForm">
          <RsljigouAll :propsjigouid="addAaminForm.jigouidneibu" :propsjigouname="addAaminForm.jigounameneibu" @change="changeRsljigouAllneibu"></RsljigouAll>
        </el-form-item>
        <el-form-item label="机构名称(实际行政归属)" class="addAdminForm">
          <RsljigouAll :propsjigouid="addAaminForm.jigouidactual" :propsjigouname="addAaminForm.jigounameactual" @change="changeRsljigouAllactual"></RsljigouAll>
        </el-form-item>
        <el-form-item label="姓名" class="addAdminForm">
          <el-input v-model="addAaminForm.nicename" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="登录名" class="addAdminForm">
          <el-input v-model="addAaminForm.loginname" placeholder="请输入登录名"></el-input>
        </el-form-item>
        <el-form-item label="密码" class="addAdminForm">
          <el-input v-model="addAaminForm.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="角色"  class="addAdminForm">
          <el-select v-model="addAaminForm.roleid" placeholder="请选择角色" class="select2">
            <el-option
              v-for="item in optionsrole" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加管理员 end -->

    <!-- 所属机构弹出框 -->
    <el-dialog title="请选所属择机构" :visible.sync="dialogAdd" width="30%" :close-on-click-modal="false">
      <!-- 头部搜索 start -->
      <el-form :inline="true" :model="select" class="demo-form-inline">
        <el-form-item label="选择机构: ">
          <el-input v-model="select.keywords" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">搜索</el-button>
        </el-form-item>
      </el-form>
      <!-- 头部搜索 end -->

      <!-- 所属机构选择 -->
      <Organization />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAdd = false">取 消</el-button>
        <el-button type="primary" @click="dialogAdd = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 所属机构弹出框 end -->
  </el-tabs>
  </div>
</template>

<script>
import Organization from '@/components/Organization.vue'
import RsljigouAll from '@/components/RsljigouAll.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Organization,
    RsljigouAll
  },
  name: 'MyAdmins',
  data () {
    return {
      loading: false,
      activeName: 'first',
      // 查询
      userSearch: {
        userName: '',
        userNiceName: '',
        idcardno: '',
        roleid: '',
        status: '',
        rulestatus: '',
        employeestype: '',
        jigouid: '0',
        jigouname: '',
        jigouidneibu: '0',
        jigounameneibu: '',
        jigouidactual: '0',
        jigounameactual: ''
      },
      // 管理员列表
      adminList: [],
      adminListnum: 0,
      dialogAdd: false,
      editUserInfo: false,
      // 添加管理员信息
      addAaminForm: {
        userid: 0,
        jigouid: '0',
        jigouname: '',
        jigouidneibu: '0',
        jigounameneibu: '',
        jigouidactual: '0',
        jigounameactual: '',
        nicename: '',
        loginname: '',
        password: '',
        roleid: '',
        rulestatus: '',
        employeestype: '',
        idcardno: '',
        idcardname: ''
      },
      optionsrole: [],
      // 选择机构
      select: {
        keywords: ''
      },
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apigeterpusernum()
    this.apigeterpuserlist()
    this.apigetallrole()
  },
  methods: {
    clickreturn () {
      this.activeName = 'first'
    },
    // 删除用户确认
    removeUserById (index, row) {
      this.$confirm('是否删除此用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apideleteerpuser(row.id)
      })
    },
    changestaus (index, row) {
      this.$confirm('是否切换状态?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiediterpuserstaus(row.id, row.userstatus)
      })
    },
    clickeditUser (index, row) {
      this.editUserInfo = true
      this.addAaminForm.userid = row.id
      this.addAaminForm.jigouid = row.jigouid
      this.addAaminForm.jigouname = row.jigouname
      this.addAaminForm.jigouidneibu = row.jigouidneibu
      this.addAaminForm.jigounameneibu = row.jigounameneibu
      this.addAaminForm.jigouidactual = row.jigouidactual
      this.addAaminForm.jigounameactual = row.jigounameactual
      this.addAaminForm.nicename = row.nicename
      this.addAaminForm.loginname = row.loginname
      this.addAaminForm.roleid = row.roleid
      this.addAaminForm.password = ''
      this.addAaminForm.rulestatus = row.rulestatus
      this.addAaminForm.employeestype = row.employeestype
      this.addAaminForm.idcardno = row.idcardno
      this.addAaminForm.idcardname = row.idcardname
    },
    changeRsljigouAll (vid, vname) {
      this.addAaminForm.jigouid = vid
      this.addAaminForm.jigouname = vname

      this.userSearch.jigouid = vid
      this.userSearch.jigouname = vname
    },
    changeRsljigouAllneibu (vid, vname) {
      this.addAaminForm.jigouidneibu = vid
      this.addAaminForm.jigounameneibu = vname

      this.userSearch.jigouidneibu = vid
      this.userSearch.jigounameneibu = vname
    },
    changeRsljigouAllactual (vid, vname) {
      this.addAaminForm.jigouidactual = vid
      this.addAaminForm.jigounameactual = vname

      this.userSearch.jigouidactual = vid
      this.userSearch.jigounameactual = vname
    },
    clickadd () {
      if (!this.addAaminForm.jigouname) {
        this.$alert('请选择机构名称(管理外部)', '提示')
        return
      }
      if (!this.addAaminForm.jigounameneibu) {
        this.$alert('请选择机构名称(管理内部)', '提示')
        return
      }
      if (!this.addAaminForm.nicename) {
        this.$alert('请输入姓名', '提示')
        return
      }
      if (!this.addAaminForm.loginname) {
        this.$alert('请输入登录名称', '提示')
        return
      }
      if (!this.addAaminForm.password) {
        this.$alert('请输入密码', '提示')
        return
      }
      if (!this.addAaminForm.roleid) {
        this.$alert('请选择角色', '提示')
        return
      }
      this.apiadderpuser()
    },
    clicksave () {
      if (!this.addAaminForm.jigouname) {
        this.$alert('请选择机构名称(管理外部)', '提示')
        return
      }
      if (!this.addAaminForm.jigounameneibu) {
        this.$alert('请选择机构名称(管理内部)', '提示')
        return
      }
      if (!this.addAaminForm.nicename) {
        this.$alert('请输入姓名', '提示')
        return
      }
      if (!this.addAaminForm.roleid) {
        this.$alert('请选择角色', '提示')
        return
      }
      this.apiediterpuser()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apigeterpusernum()
      this.apigeterpuserlist()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigeterpuserlist()
    },
    apigeterpusernum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        username: that.userSearch.userName,
        usernicename: that.userSearch.userNiceName,
        idcardno: that.userSearch.idcardno,
        roleid: that.userSearch.roleid,
        status: that.userSearch.status,
        rulestatus: that.userSearch.rulestatus,
        employeestype: that.userSearch.employeestype,
        jigouid: that.userSearch.jigouid,
        jigouidneibu: that.userSearch.jigouidneibu,
        jigouidactual: that.userSearch.jigouidactual
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Geterpusernum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.adminListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigeterpuserlist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        username: that.userSearch.userName,
        usernicename: that.userSearch.userNiceName,
        idcardno: that.userSearch.idcardno,
        roleid: that.userSearch.roleid,
        status: that.userSearch.status,
        rulestatus: that.userSearch.rulestatus,
        employeestype: that.userSearch.employeestype,
        jigouid: that.userSearch.jigouid,
        jigouidneibu: that.userSearch.jigouidneibu,
        jigouidactual: that.userSearch.jigouidactual
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Geterpuserlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.adminList = []
            response.data.List.filter((item1, i1) => {
              var userstatuss = '禁用'
              if (item1.Userstatus == 1) {
                userstatuss = '正常'
              }
              var rulestatuss = '否'
              if (item1.Rulestatus == 1) {
                rulestatuss = '是'
              }
              var employeestypes = '否'
              if (item1.Employeestype == 1) {
                employeestypes = '是'
              }
              if (item1.Employeestype == 2) {
                employeestypes = '离职'
              }
              that.adminList.push({ id: item1.Id, loginname: item1.Loginname, nicename: item1.Nicename, rolename: item1.Rolename, roleid: item1.Roleid, lastloginip: item1.Lastloginip, lastlogintime: item1.Lastlogintime, userstatus: item1.Userstatus, userstatuss: userstatuss, rulestatus: '' + item1.Rulestatus, employeestype: '' + item1.Employeestype, idcardno: item1.Idcardno, idcardname: item1.Idcardname, rulestatuss: rulestatuss, employeestypes: employeestypes, jigouid: item1.Jigouid.toString(), jigouname: item1.Jigouname, jigouidneibu: item1.Jigouidneibu.toString(), jigounameneibu: item1.Jigounameneibu, jigouidactual: item1.Jigouidactual.toString(), jigounameactual: item1.Jigounameactual })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apigetallrole: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getallrole, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.optionsrole = []
            response.data.List.filter((item1, i1) => {
              that.optionsrole.push({ value: item1.Id, label: item1.Name })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiadderpuser: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: this.addAaminForm.jigouid,
        jigouidneibu: this.addAaminForm.jigouidneibu,
        jigouidactual: this.addAaminForm.jigouidactual,
        nicename: this.addAaminForm.nicename,
        loginname: this.addAaminForm.loginname,
        password: this.addAaminForm.password,
        roleid: this.addAaminForm.roleid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Adderpuser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apigeterpusernum()
            that.apigeterpuserlist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiediterpuser: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        userid: this.addAaminForm.userid,
        jigouid: this.addAaminForm.jigouid,
        jigouidneibu: this.addAaminForm.jigouidneibu,
        jigouidactual: this.addAaminForm.jigouidactual,
        nicename: this.addAaminForm.nicename,
        password: this.addAaminForm.password,
        roleid: this.addAaminForm.roleid,
        rulestatus: this.addAaminForm.rulestatus,
        employeestype: this.addAaminForm.employeestype,
        idcardno: this.addAaminForm.idcardno,
        idcardname: this.addAaminForm.idcardname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editerpuser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.editUserInfo = false
            that.apigeterpusernum()
            that.apigeterpuserlist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiediterpuserstaus: function (userid, userstatus) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        userid: userid,
        staus: userstatus.toString()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editerpuserstaus, Qs.stringify(data))
        .then(function (response) {
          that.apigeterpuserlist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apideleteerpuser: function (userid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        userid: userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Deleteerpuser, Qs.stringify(data))
        .then(function (response) {
          that.apigeterpuserlist()
		  Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
